<template>
    <div id="app">
        <div class="content">
            <div class="left-image">
                <div class="text-top title">保护地球</div>
                <div class="text-bottom title">从我做起</div>
            </div>
            <div class="right-table">
                <table>
                    <tr>
                        <td>作品名称</td>
                        <td>保护地球 （2021复刻版）</td>
                    </tr>

                    <tr>
                        <td>主题</td>
                        <td>保护地球，从我做起</td>
                    </tr>

                    <tr>
                        <td>姓名</td>
                        <td>fubo</td>
                    </tr>
                    <tr>
                        <td>班级</td>
                        <td>高一（5）班</td>
                    </tr>
                    <tr>
                        <td>网站数量</td>
                        <td>39</td>
                    </tr>
                    <tr>
                        <td>素材来源</td>
                        <td>网上</td>
                    </tr>
                    <tr>
                        <td>作品大小</td>
                        <td>36.3MB （占用38.7MB空间）</td>
                    </tr>
                    <tr>
                        <td>视频素材</td>
                        <td>FLV格式（复刻后均转换成了mp4格式）</td>
                    </tr>
                    <tr>
                        <td>音频素材</td>
                        <td>班得瑞 - SnowDream（背景音乐，因为我当时喜欢这个音乐，Chrome可能需要点击右上角播放才能开始自动播放。）</td>
                    </tr>
                    <tr>
                        <td>导航栏参照</td>
                        <td><a href="https://web.archive.org/web/20091027223820/https://news.163.com/" target="_blank">网易新闻网(WebArchive - 2009年)</a></td>
                    </tr>
                    <tr>
                        <td>本地链接测试</td>
                        <td>所有链接正常</td>
                    </tr>
                    <tr>
                        <td>制作</td>
                        <td>最初于2009年用FrontPage制作，在2021年5月17日进行完整复刻，虽然有些页面背景和内容颜色选择不是很合适，有些图片连白色底色都没去掉，但是，这都是那一刻最真实的样子。</td>
                    </tr>
                </table>
            </div>
            <div class="clear"></div>
            <div class="bottom">
                <div class="bt-th center limit-width">可能存在的欠缺</div>
                <div class="bt-th">
                    <div class="th">第一幅是在1024X768 IE全屏时候的画面(十分正常）</div>
                    <div class="tb-img">
                        <img src="../assets/images/bad1.jpg" />
                    </div>
                </div>
                <div class="bt-th">
                    <div class="th">第二幅是在1024X768
                        IE窗口时候的画面（画面脱离位置）</div>
                    <div class="tb-img">
                        <img src="../assets/images/bad2.jpg" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "IntroduceView"
    }
</script>

<style lang="scss" scoped>
    .content {
        $totalHeight: 748px;
        $imgHeight: 480px;
        background: url("../assets/images/dahai.jpg");
        width: $totalHeight;
        background-size: cover;
        .left-image {
            float: left;
            width: 47%;
            marign-top: 20%;
            height: $imgHeight;
            background: url("../assets/images/dashu1.jpg") no-repeat;
            background-size: contain;
            text-align: center;
            .title {
                text-align: center;
                -webkit-text-stroke: 0.05em #33c;
                -webkit-text-fill-color : transparent;
                font-size: 36px;
                text-shadow: 3px 3px 2px #b2b2b2;
                font-family: SimSun;
            }
            .text-top {
                margin-top: 40px;
            }
            .text-bottom {
                margin-top: 50px;
            }

        }
        .right-table {
            margin-left: 50%;
            table {
                color: #800000;
                font-size: 18px;
                tr {
                    line-height: 28px;
                    td:first-child {
                        width: 80px !important;
                    }
                    td {
                        font-size: 13px;
                    }
                }
            }
        }
        .bottom {
            height: $totalHeight - $imgHeight - 100;

            .bt-th {
                font-size: 13px;
                color: #800000;
                height: 100%;
                overflow: hidden;
                float: left;
                width: 35%;
                margin-left: 3%;
                &.center {
                    line-height: $totalHeight - $imgHeight - 100;
                }
                &.limit-width {
                    width: 15%;
                }
            }
        }

    }
</style>